import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../components/ui/dialog";

export function ChangePassword() {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const h = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (f.next.length < 8) return toast.error("New password must be at least 8 characters");
    if (f.next !== f.confirm) return toast.error("New passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Password updated");
      setF({ current: "", next: "", confirm: "" });
      setOpen(false);
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Could not update password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button data-testid="admin-change-password-button" onClick={() => setOpen(true)}
        className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-[13.5px] text-white/70 hover:text-white hover:bg-white/10 transition-colors">
        <KeyRound size={16} /> Change Password
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-[400px]" data-testid="change-password-dialog">
          <DialogHeader>
            <DialogTitle className="font-[Poppins] text-[var(--pg-navy)]">Change Password</DialogTitle>
            <DialogDescription>Update the password for your account. Minimum 8 characters.</DialogDescription>
          </DialogHeader>
          <form onSubmit={submit} className="space-y-3.5">
            <div>
              <label className="pg-label">Current Password</label>
              <input data-testid="cp-current-input" type="password" required autoComplete="current-password"
                className="pg-input !py-2.5" value={f.current} onChange={h("current")} />
            </div>
            <div>
              <label className="pg-label">New Password</label>
              <input data-testid="cp-new-input" type="password" required minLength={8} autoComplete="new-password"
                className="pg-input !py-2.5" value={f.next} onChange={h("next")} />
            </div>
            <div>
              <label className="pg-label">Confirm New Password</label>
              <input data-testid="cp-confirm-input" type="password" required autoComplete="new-password"
                className="pg-input !py-2.5" value={f.confirm} onChange={h("confirm")} />
            </div>
            <button data-testid="cp-submit-button" type="submit" disabled={busy}
              className="btn-primary w-full !py-3 text-[13px] justify-center disabled:opacity-60">
              {busy ? <Loader2 className="animate-spin" size={16} /> : "Update Password"}
            </button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
